import TSettingUserList from './index.vue';

TSettingUserList.install = app => {
  app.component(TSettingUserList.name, TSettingUserList);
};

export default TSettingUserList;
